export enum GravityEnum {
    emergencia = 1,
    muitoUrgente = 2,
    urgente = 3,
    poucoUrgente = 4,
    naoUrgente = 5,
    obito = 6,
    branco = 7
}